define.alias("ember-composable-helpers/helpers/toggle", "calendar/helpers/toggle");